import {
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";

export const Verify_accountgroup = async (groupid) => {
  console.log("Verify_accountgroup called with:", groupid);

  // ---------- BASIC VALIDATION ----------
  if (!groupid || typeof groupid !== "string" || groupid.trim() === "") {
    return { success: false, error: "Missing groupid" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }

  if (
    !select_company_uid ||
    select_company_uid === "undefined" ||
    select_company_uid === "null"
  ) {
    return { success: false, error: "Company not selected." };
  }

  try {
    /* ---------- MASTER GROUP CHECK ---------- */
    const masterRef = collection(db, "accounting_groups_list_master");
    const masterQuery = query(
      masterRef,
      where("groupid", "==", groupid.trim())
    );

    const masterSnap = await getDocs(masterQuery);

    if (!masterSnap.empty) {
      return {
        success: true, 
        data: masterSnap.docs[0].data()
      };
    }
 
    /* ---------- FINAL SAFE RETURN ---------- */
    return {
      success: false,
      error: "Group ID not found"
    };

  } catch (err) {
    console.error("Verify_accountgroup error:", err);
    return {
      success: false,
      error: err?.message || "Unknown error"
    };
  }
};
